var map = {
	"./locales/a.js": "89dd",
	"./locales/apiCode.js": "713b",
	"./locales/code.js": "0c5b",
	"./locales/en.js": "090b",
	"./locales/ja.js": "1105",
	"./locales/ko.js": "41f5",
	"./locales/th.js": "52f8",
	"./locales/zh.js": "abac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f0f";